export enum ParamterType {
  NONE = 'NONE', STRING = 'STRING', NUMBER = 'NUMBER'
}

export class SupplementaryEquipment {
  key: string;
  dictionaryKey: string;
  selected: boolean;
  selectedIdentifier?: string;
  availableIdentifiers: Array<string>;
  parameter1DictionaryKey: string;
  parameter1Type: ParamterType;
  parameter1Value: string;
}

export class SupplementaryEquipmentHandout {
  visitId: number;
  firstname: string;
  name: string;
  company: string;
  supplementaryEquipments: SupplementaryEquipment[] = [];
}
